import React, { useState } from 'react';
import { MatchResult } from '../models/match-result';
import { Badge, Button } from 'react-bootstrap';

import { isMobile } from 'react-device-detect';
import { Player } from '../models/player';

interface Props {
    matchResult: MatchResult;
    minHighBreak?: number;
    permanentDetails?: boolean;
}

export const MatchReport = (props: Props) => {
    const { matchResult, permanentDetails } = props;
    const bestOf = matchResult.distance > 0 ? matchResult.distance : Math.max(matchResult.player1Frames, matchResult.player2Frames) * 2 - 1;
    const maxNumberOfBreaks = 5;
    const [showDetails, setShowDetails] = useState(permanentDetails ?? false);

    let p1HighestBreak = 0;
    matchResult.player1FrameResults.forEach(result => {

        p1HighestBreak = Math.max(p1HighestBreak, Math.max(...result.breaks));

    });

    let p2HighestBreak = 0;
    matchResult.player2FrameResults.forEach(result => {

        p2HighestBreak = Math.max(p2HighestBreak, Math.max(...result.breaks));

    });

    const minHighBreak = isNaN(props.minHighBreak ?? 30) ? 30 : props.minHighBreak ?? 30;

    const getLinkName = (player: Player, isMobile: boolean) => {
        let name = isMobile ? player?.firstName[0] + "." : player?.firstName;
        name = `${name} ${player?.lastName}`
        return (
            <a href={`/players/${player.id}`}>{name}</a>
        )
    }

    const getName = (match: MatchResult, isMobile: boolean, index: number) => {
        if (index == 1) {
            if (match.player1Name) {
                if (isMobile && match.player1Name.includes(' ')) {
                    const parts = match.player1Name.split(' ');
                    const initials = parts.slice(0, -1).map(part => part[0] + '.').join(' ');
                    return `${initials} ${parts[parts.length - 1]}`;
                }
                else {
                    return match.player1Name;
                }
            }
            else {
                return getLinkName(matchResult.player1, isMobile);
            }
        }
        else {
            if (match.player2Name) {
                if (isMobile && match.player2Name.includes(' ')) {
                    const parts = match.player2Name.split(' ');
                    const initials = parts.slice(0, -1).map(part => part[0] + '.').join(' ');
                    return `${initials} ${parts[parts.length - 1]}`;
                }
                return match.player2Name;
            }
            else {
                return getLinkName(matchResult.player2, isMobile);
            }
        }
    }

    const getNameWithHandicap = (match: MatchResult, isMobile: boolean, index: number) => {
        const handicap = index == 1 ? match.player1Handicap : match.player2Handicap;

        return (
            <>
                {getName(match, isMobile, index)}
                {handicap > 0 &&
                    <span className='handicap' title={`Player has handicap ${handicap}`}>&nbsp;(H:{handicap})</span>
                }
            </>
        )

    }

    var date = new Date(matchResult.createdAt);

    var options = { hour: '2-digit', minute: '2-digit' };
    var time = date.toLocaleString('sv', options);

    var dayOptions = { month: '2-digit', day: '2-digit' };
    var day = date.toLocaleString('sv', dayOptions);

    var yearOptions = { year: 'numeric' };
    var year = date.toLocaleString('sv', yearOptions);

    var mobileDateOptions = { month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }
    var mobileDate = date.toLocaleString('sv', mobileDateOptions);

    const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')} ${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;

    return (
        <div className='match-report-container'>
            {!isMobile && <>
                {matchResult.matchNo ?
                    <div className="cs-match-no"><a target='blank' href={`https://cuescore.com/tournament/a/${matchResult.tournamentId}`}>{matchResult.matchNo}</a></div>
                    :
                    <div className='cs-match-no empty-match-no' />
                }
                <div className={matchResult.isDone ? `cs-match-time` : `cs-match-time-live`}>
                    <div>
                        {day}
                    </div>
                    <div>
                        {year}
                    </div>
                    <div>
                        {time}
                    </div>
                </div>
            </>
            }
            <div className='match-report'>
                {isMobile &&
                    <div className='mobile-date'>
                        <div>
                            {formattedDate}
                        </div>
                        {matchResult.tournamentId ?
                            <div className='match-type tournament'>Tournament</div>
                            :
                            <div className='match-type practice'>Practice</div>
                        }
                    </div>
                }
                <div className='title'>
                    <div className={`name${isMobile ? " mobile" : ""}`}>{getNameWithHandicap(matchResult, isMobile, 1)}</div>
                    <div className='final-score'>{matchResult.player1Frames} </div>
                    <div className='final-score'>({bestOf})</div>
                    <div className='final-score'>{matchResult.player2Frames}</div>
                    <div className={`name${isMobile ? " mobile" : ""}`}>{getNameWithHandicap(matchResult, isMobile, 2)}</div>
                </div>
                <div className='frame-area'>
                    <div className='frame-column'>
                        {showDetails &&
                            <>
                                <div className='frame-report'>
                                    <div className={`breaks${isMobile ? " mobile" : ""}`}>Breaks ({minHighBreak}+)</div><div className={`score`}>Score</div>
                                </div>
                                {matchResult.player1FrameResults.map(result =>
                                    <div key={matchResult.id + matchResult.player1.id + result.index} className='frame-report'>
                                        <div className={`breaks${isMobile ? " mobile" : ""} divider`}>{result.breaks.filter(x => x >= minHighBreak).slice(0, maxNumberOfBreaks).join(', ')}</div><div className={`score ${result.won ? 'won' : 'lost'}`}>{result.score}</div>
                                    </div>
                                )}
                            </>
                        }

                    </div>
                    <div className='frame-column'>
                        {showDetails &&
                            <>
                                <div className='frame-report'>
                                    <div className={`score`}>Score</div><div className={`breaks${isMobile ? " mobile" : ""} `}>Breaks ({minHighBreak}+)</div>
                                </div>
                                {matchResult.player2FrameResults.map(result =>
                                    <div key={matchResult.id + matchResult.player2.id + result.index} className='frame-report'>
                                        <div className={`score ${result.won ? 'won' : 'lost'} divider`}>{result.score}</div><div className={`breaks${isMobile ? " mobile" : ""} `}>{result.breaks.filter(x => x >= minHighBreak).slice(0, maxNumberOfBreaks).join(', ')}</div>
                                    </div>
                                )}
                            </>
                        }

                    </div>
                </div>
                <div className='bottom'>
                    <div className={`text${isMobile ? " mobile" : ""}`}>{isMobile ? "HB:" : "Highest break:"} {p1HighestBreak}</div>
                    <div className='details'>
                        {!permanentDetails &&
                            <a href='#' onClick={(event) => { event.preventDefault(); setShowDetails(!showDetails) }}>{showDetails ? "Hide" : "Show more"}</a>}
                    </div>
                    <div className={`text${isMobile ? " mobile" : ""}`}>{isMobile ? "HB:" : "Highest break:"} {p2HighestBreak}</div>
                </div>

            </div>
            {!isMobile &&
                <div className='match-browser'>
                    {matchResult.tournamentId ?
                        <div className='match-type tournament'>Tourn{showDetails ? 'ament' : '.'}</div>
                        :
                        <div className='match-type practice'>Practice</div>
                    }
                </div>
            }
        </div>
    );
}